// bounty
import {isInstanceOf} from '@acng/frontend-bounty/std/value.js';
import {add, clear, createSet, has} from '@acng/frontend-bounty/collection.js';
import {HTMLDetailsElement} from '@acng/frontend-bounty/dom/type.js';
import {attributeSelector, getParentElement, matches} from '@acng/frontend-bounty/dom/query.js';
import {setTimeout} from '@acng/frontend-bounty/dom/window.js';
import {get, OPEN} from '@acng/frontend-bounty/dom/attribute.js';
import {debug} from '@acng/frontend-bounty/dom/debug.js';
import {all} from '@acng/frontend-bounty/dom/document.js';
// nova
import {AUTO_CLOSE} from '../attribute/auto-close.js';
import {STYLE_CLOSED, swapClass} from './style.js';

/**
 * @type {Set<Element>}
 */
const skipElements = createSet();

/**
 * @param {Element | null} [keepOpen]
 * @param {boolean} [defer]
 */
export const closeAll = (keepOpen = null, defer) => {
  for (; keepOpen; keepOpen = getParentElement(keepOpen)) {
    add(skipElements, keepOpen);
  }

  if (defer) {
    return;
  }

  const includeElements = all(attributeSelector(AUTO_CLOSE));
  //DEBUG: if (VERBOSE) console.debug(MODULE, {includeElements, skipElements: [...skipElements]});

  for (const details of includeElements) {
    const selectors = get(details, AUTO_CLOSE);

    if (!has(skipElements, details) && (!selectors || matches(details, selectors))) {
      DEBUG: if (debug(details)) console.log('auto close', {details});

      if (isInstanceOf(details, HTMLDetailsElement)) {
        details[OPEN] = false;
      }

      swapClass(details, STYLE_CLOSED, true);
    }
  }

  setTimeout(() => clear(skipElements));
};
